import { Toast } from 'vant';
import { localStorageUtil } from '@/utils';
import { state, formData, findFormData, initFindFormData, mobileReg, countDownFn } from './data';
import { reportsms, getfeedback } from './api';
export default {
  findSendSMS() {
    const tel = findFormData.tel;
    if (!mobileReg.test(tel)) {
      Toast.fail('请输入正确的手机号码');
      return;
    }
    reportsms(tel).then(res => {
      countDownFn(state.findSMS);
      localStorageUtil.setItem('findInfoTokenNew', res, 86400);
    });
  },
  onSubmitFind(data) {
    getfeedback(data).then(res => {
      state.replyData = res;
      Object.assign(formData, initFindFormData());
    });
  },
  reFindReply() {
    state.isReplyFind = false;
  },
  verifyUpdateFind(s) {
    state.disabledFindSubmit = s.length !== 6;
  }
};
